import { lazy } from "react";

import SetAppointment from "./SetAppointment/SetAppointment";


const CustomerIdentification = lazy(() => import("./CustomerIdentification/CustomerIdentification"));
const AppointmentDetails = lazy(() => import("./AppointmentDetails/AppointmentDetails"));
// const SetAppointment = lazy(() => import("./SetAppointment/SetAppointment"));
const ServiceType = lazy(() => import("./ServiceType/ServiceType"));
const Questions = lazy(() => import("./Questions/Questions"));
const Calendar = lazy(() => import("./Calendar/Calendar"));
const Location = lazy(() => import("./Location/Location"));
const Error = lazy(() => import("./Errors/Errors"));
const Details = lazy(() => import("./Details/Details"));
const Service = lazy(() => import("./Service/Service"));

export {
    CustomerIdentification,
    AppointmentDetails,
    SetAppointment,
    ServiceType,
    Calendar,
    Location,
    Error,
    Details,
    Service,
    Questions
}